import PropTypes from "prop-types";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

// Vision UI Dashboard React example components
import PageLayout from "examples/LayoutContainers/PageLayout";

// Authentication layout components
import Footer from "layouts/authentication/components/Footer";

// Vision UI Dashboard React theme functions
import colors from "assets/theme/base/colors";
import tripleLinearGradient from "assets/theme/functions/tripleLinearGradient";

function CenteredLayout({ color, header, title, description, children }) {
  const { gradients } = colors;
  return (
    <PageLayout
      background={tripleLinearGradient(
        gradients.cover.main,
        gradients.cover.state,
        gradients.cover.stateSecondary,
        gradients.cover.angle
      )}
    >
      <VuiBox
        sx={{
          display: "flex",
          flexDirection: "column", // Stack children vertically
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh", // Full viewport height
          margin: "0 auto",
        }}
      >
        <VuiBox width="100%" maxWidth="960px"> {/* Constrain width of the content card */}
          <VuiBox pt={3} px={3} mx="auto !important">
            {!header ? (
              <>
                <VuiBox mb="35px" textAlign="center">
                  <VuiTypography variant="h3" fontWeight="bold" color={color} mb="10px">
                    {title}
                  </VuiTypography>
                  <VuiTypography
                    sx={({ typography: { size } }) => ({
                      fontWeight: "regular",
                      fontSize: size.sm,
                    })}
                    color="white"
                  >
                    {description}
                  </VuiTypography>
                </VuiBox>
              </>
            ) : (
              header
            )}
          </VuiBox>
          <VuiBox px={3} mb="50px" mx="auto">
            {children}
          </VuiBox>
          <Footer />
        </VuiBox>
      </VuiBox>
    </PageLayout>
  );
}

CenteredLayout.defaultProps = {
  header: "",
  title: "",
  description: "",
  color: "info",
};

CenteredLayout.propTypes = {
  header: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default CenteredLayout;
